import { log } from '../utils/Logger'

export function sendPostMessage(message, params = {}) {
  window.parent.postMessage({
    ...params,
    type: message,
  }, '*')
  log(`Sending postMessage: ${message} with params: ${JSON.stringify(params)}`, 'SERVER')
}
